import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';

import './styles/app.css';
// Generated from the token registry by `npm run build:css`. The editor preview and the
// Webflow export therefore share one definition rather than two implementations of it.
import './styles/generated.lp.css';

const root = document.getElementById('root');
if (!root) throw new Error('No #root element.');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
